import { Button } from "@tfg/ui"
import { Box, Group } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { InlineBanner } from "~/components/InlineBanner"

export type OnboardingGateRetryBannerProps = Readonly<{
  onRetry: () => void
}>

export const OnboardingGateRetryBanner = ({
  onRetry,
}: OnboardingGateRetryBannerProps) => {
  const { t } = useTranslation("supplier")

  return (
    <Box px="var(--tfg-layout-padding-x)" pt="sm">
      <InlineBanner
        type="error"
        message={t("onboarding.gate.retryBanner.message")}
        closable={false}
      >
        <Group justify="flex-end">
          <Button variant="secondary-critical" size="xs" onClick={onRetry}>
            {t("onboarding.gate.retryBanner.retry")}
          </Button>
        </Group>
      </InlineBanner>
    </Box>
  )
}

export type OnboardingGateRetryScreenProps = Readonly<{
  onRetry: () => void
}>

export const OnboardingGateRetryScreen = ({
  onRetry,
}: OnboardingGateRetryScreenProps) => (
  <Box mih="100vh" display="flex" style={{ alignItems: "center" }}>
    <Box w="100%">
      <OnboardingGateRetryBanner onRetry={onRetry} />
    </Box>
  </Box>
)
